@if (contentlet$ | async; as contentlet) {
<!--  image with textAlign -->
<ng-template #imageWithTextAlign>
  <a [routerLink]="contentlet.link" [attr.title]="contentlet.title">
    @if (buildImageSrc('fileAsset') | async | dotCmsCodecEncode; as imageSrc) {
    <div
      [id]="'image-container-' + contentlet.identifier"
      [ngClass]="contentlet.cssClass"
      [ngStyle]="{ 'text-align': contentlet.textAlign }"
    >
      <img
        [id]="'image-' + contentlet.identifier"
        [class]="
          (animationTriggered$ | async)
            ? getImageAnimationCss(contentlet.imageAnimation, contentlet.identifier, imageSrc)
            : ''
        "
        loading="lazy"
        [src]="imageSrc"
        [alt]="contentlet.alt"
        [title]="contentlet.title"
      />
    </div>
    }
  </a>
</ng-template>
<!--Dotcms-image -->
<ng-template #defaultImage>
  <div class="default-image-class">
    <div class="dot-cms-image-wrapper">
      <a
        [attr.title]="contentlet.linkTitle || contentlet.title"
        class="teaser-link"
        (click)="selectPromotionGTMEvent()"
      >
        @if (buildImageSrc('fileAsset') | async | dotCmsCodecEncode; as imageSrc) {
        <div [id]="'image-container-' + contentlet.identifier" [ngClass]="contentlet.cssClass">
          <img
            [id]="'image-' + contentlet.identifier"
            [class]="
              (animationTriggered$ | async)
                ? getImageAnimationCss(contentlet.imageAnimation, contentlet.identifier, imageSrc)
                : ''
            "
            loading="lazy"
            [src]="imageSrc"
            [attr.alt]="contentlet.alternateText || contentlet.title"
          />
        </div>
        }
      </a>
    </div>
  </div>
</ng-template>
<ng-container *ngTemplateOutlet="contentlet?.textAlign ? imageWithTextAlign : defaultImage" />
}
